/**
 * The width the live preview is LAID OUT at, before any scaling.
 *
 * 🚨 460px is the modal panel's own width (`form-tree/src/theme.ts`, which pins it to match the
 * legacy `.cod-modal { max-width: 460px }`). Laying out at a fixed reference is the whole trick:
 * left to fill its container the panel reflowed to ~302px on a phone, and a reflowed form is not
 * the buyer's form — prices broke mid-number, a placeholder ran out of its input and the submit
 * label wrapped inside its button. None of that happens on a storefront; all of it was the
 * Designer lying about the layout, which is the one thing this screen exists not to do.
 */
export const PREVIEW_REFERENCE_WIDTH = 460;

/**
 * How much to shrink the preview so `reference` px of content fit in `available` px of column.
 *
 * 🚨 Never scales UP. A desktop column is wider than the form, and stretching the preview to fill
 * it would be the same lie in the other direction — the buyer's form is 460px, not 700px.
 * Degenerate widths (a column measured before layout, a hidden tab) return 1 rather than 0, so the
 * preview renders at true size instead of collapsing to nothing.
 */
export function fitScale(available: number, reference = PREVIEW_REFERENCE_WIDTH): number {
  if (!(available > 0) || !(reference > 0)) return 1;
  return Math.min(1, available / reference);
}
